module.exports = __webpack_public_path__ + "media/images/flags/1x1/bgd-36b1be9fd5183a68e03c32f6ce9b4f3a.svg";